/* Independent decorative motes. Never intercept links, images, or pointer input. */
(() => {
  if (document.querySelector('[data-rin-motes-personality]')) return;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = matchMedia('(max-width: 749px)');
  const field = document.createElement('div');
  field.className = 'rin-mote-field';
  field.dataset.rinMotesPersonality = '';
  field.setAttribute('aria-hidden', 'true');
  document.body.append(field);
  const random = (a, b) => a + Math.random() * (b - a);
  let width = innerWidth, height = innerHeight, particles = [], frame = 0, last = 0, time = 0;
  let pointer = null, highlighted = null, bounds = null, refreshBounds = false, touchUntil = 0;
  const selector = '.rin-card,.rin-gift-feature,product-card,.resource-card,.collection-card,.card-gallery,.product-media-container,.product-media,button,a[href],summary';
  function measure() {
    width = innerWidth; height = innerHeight;
    bounds = highlighted?.isConnected ? highlighted.getBoundingClientRect() : null;
    refreshBounds = false;
  }
  function build() {
    field.replaceChildren(); particles = [];
    const fragment = document.createDocumentFragment();
    for (let i = 0; i < (narrow.matches ? 34 : 64); i++) {
      const roll = Math.random(), depth = roll < .42 ? 'far' : roll < .86 ? 'mid' : 'hot';
      const hot = depth === 'hot', far = depth === 'far';
      const el = document.createElement('span');
      el.className = `rin-mote rin-mote--${depth}${hot || (!far && i % 9 === 0) ? ' rin-mote--reactive' : ''}`;
      const alpha = far ? random(.34,.58) : hot ? random(.76,.96) : random(.52,.82);
      for (const [key,value] of Object.entries({size:`${far ? random(1.6,3.8) : hot ? random(6,12.5) : random(2.8,6.8)}px`,alpha, 'breath-low':alpha*.72,breathe:`${random(3.8,7.2)}s`,'breath-delay':`${-random(0,6)}s`,glow1:`${hot ? 12 : random(5,11)}px`,glow2:`${hot ? 28 : random(10,24)}px`,'react-size':`${hot ? random(112,168) : random(82,126)}px`})) el.style.setProperty(`--${key}`,value);
      const x = random(.03,.97), y = random(.03,.97);
      el.style.transform = `translate3d(${x*width}px,${y*height}px,0)`;
      particles.push({el,x,y,phase:random(0,Math.PI*2),speed:random(.11,.29),wander:random(20,65),personality:i%3,sociable:!far && i%3!==0,lag:random(1.3,3.8),dx:0,dy:0});
      fragment.append(el);
    }
    field.append(fragment);
  }
  function tick(now) {
    frame = 0;
    if (motion.matches || document.hidden) return;
    if (last && now-last < 32) { frame=requestAnimationFrame(tick); return; }
    const dt = last ? Math.min((now-last)/1000,.08) : .032;
    last=now; time+=dt;
    if (refreshBounds) measure();
    if (touchUntil && now>touchUntil) {highlighted=null;bounds=null;touchUntil=0;}
    const target = bounds && bounds.bottom>0 && bounds.top<height ? bounds : null;
    particles.forEach((p,i) => {
      const phase = time*p.speed+p.phase;
      const x=p.x*width+Math.sin(phase)*p.wander+Math.sin(phase*.61+p.phase)*12;
      const y=p.y*height+Math.cos(phase*.79)*p.wander*.8;
      let dx=0,dy=0;
      if (target && p.sociable) {
        // Each curious mote chooses its own point around the highlighted object.
        const angle=p.phase+time*(p.personality===2?.16:.04);
        const tx=target.left+target.width/2+Math.cos(angle)*(Math.min(target.width/2,180)+18);
        const ty=target.top+target.height/2+Math.sin(angle)*(Math.min(target.height/2,190)+18);
        dx=(tx-x)*.8;dy=(ty-y)*.8;
      } else if (pointer) {
        const px=pointer.x-x,py=pointer.y-y,distance=Math.hypot(px,py);
        const influence=Math.max(0,1-distance/(p.personality===0?150:260));
        if(p.personality===0) {dx=-px*influence*.65;dy=-py*influence*.65;}
        else if(p.personality===1) {dx=px*influence*.55;dy=py*influence*.55;}
        else {dx=(px+Math.cos(phase*3)*38)*influence*.65;dy=(py+Math.sin(phase*3)*38)*influence*.65;}
      }
      const ease=1-Math.exp(-dt*p.lag);
      p.dx+=(dx-p.dx)*ease;p.dy+=(dy-p.dy)*ease;
      const cx=Math.max(-25,Math.min(width+25,x+p.dx)),cy=Math.max(-25,Math.min(height+25,y+p.dy));
      p.el.style.transform=`translate3d(${cx.toFixed(1)}px,${cy.toFixed(1)}px,0)`;
    });
    frame=requestAnimationFrame(tick);
  }
  function start() {
    cancelAnimationFrame(frame);frame=0;last=0;
    document.documentElement.toggleAttribute('data-rin-motion-paused',document.hidden);
    if(!motion.matches && !document.hidden)frame=requestAnimationFrame(tick);
  }
  function highlight(node) {
    const next=node instanceof Element ? node.closest(selector) : null;
    if(next===highlighted)return;
    highlighted=next;refreshBounds=true;
  }
  window.addEventListener('pointermove',event=>{if(event.pointerType==='touch')return;pointer={x:event.clientX,y:event.clientY};highlight(document.activeElement?.matches(':focus-visible')?document.activeElement:event.target);},{passive:true});
  document.documentElement.addEventListener('pointerleave',()=>{pointer=null;highlight(null);});
  document.addEventListener('focusin',event=>highlight(event.target));
  document.addEventListener('focusout',()=>highlight(null));
  document.addEventListener('pointerdown',event=>{if(event.pointerType==='touch'){highlight(event.target);touchUntil=performance.now()+1800;}},{passive:true});
  window.addEventListener('scroll',()=>{refreshBounds=true;},{passive:true});
  window.addEventListener('resize',()=>{refreshBounds=true;},{passive:true});
  narrow.addEventListener('change',()=>{measure();build();start();});
  motion.addEventListener('change',start);
  document.addEventListener('visibilitychange',start);
  window.addEventListener('pagehide',()=>{cancelAnimationFrame(frame);frame=0;});
  window.addEventListener('pageshow',start);
  build();start();
})();

(() => {
  if (document.querySelector('[data-rin-ambient-v5]')) return;



  const layer = document.createElement('div');
  layer.className = 'rin-ambient-v5';
  layer.dataset.rinAmbientV5 = '';
  layer.setAttribute('aria-hidden', 'true');
  layer.innerHTML = `
    <span class="rin-ambient-light rin-ambient-light--left"></span>
    <span class="rin-ambient-light rin-ambient-light--right"></span>
    <span class="rin-ambient-light rin-ambient-light--violet"></span>
  `;
  document.body.appendChild(layer);
})();

